import { gql } from "@apollo/client";

export const PASSENGER = gql`
  query queryPassenger($id: Float!) {
    passenger(id: $id) {
      id
      phone
      name
      cpf
      image_path
      evaluation
      created_at
      updated_at
    }
  }
`;

export const PASSENGERS = gql`
  query queryPassengers($filter: FilterPassengerInput) {
    passengers(filter: $filter) {
      id
      name
      phone
      image_path
      cpf
      evaluation
      franchise {
        id
        name
      }
    }
    franchises {
      id
      name
    }
  }
`;

export default PASSENGER;
